export default __webpack_public_path__ + "static/media/dashboard-head.acc32a9a.png";